import { Typography } from '@mui/material';

import ChartBoxMultipleOutline from '@/assets/icons/ChartBoxMultipleOutline';
import AccordionSection from '@/features/DataHub/components/AccordionSection';
import { Preview } from '@/features/DataHub/components/Preview/Preview';

const PreviewAccordion = () => {
  return (
    <AccordionSection
      icon={<ChartBoxMultipleOutline />}
      title='Chart view'
    >
      <Typography
        sx={{
          fontSize: '12px',
          color: 'text.disabled'
        }}
      >
        Chart displays up to 6 items
      </Typography>
      <Preview />
    </AccordionSection>
  );
};

export default PreviewAccordion;
